/**
 * pages/knowledge/theme.js — Минутын мэдлэг (М-Мэдлэг) модулийн өнгө.
 *
 * Модулийг брэндийн ногооноос ялгаж, ЦАЙВАР ЦЭНХЭР өнгөөр таниулна.
 * Мобайл талд ижил утгууд: hse_mobile/src/theme/colors.ts → colors.knowledge*
 */
export const KNOWLEDGE = "#0EA5E9"; // үндсэн — товч, тэмдэглэгээ
export const KNOWLEDGE_DARK = "#0284C7"; // гарчиг, тод текст
export const KNOWLEDGE_LIGHT = "#E0F2FE"; // дэвсгэр
export const ON_KNOWLEDGE_LIGHT = "#075985"; // цайвар дэвсгэр дээрх текст

/** /me дээрх «М-Мэдлэг» товчны градиент. */
export const KNOWLEDGE_GRADIENT =
  "linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)";
export const KNOWLEDGE_SHADOW = "0 3px 12px rgba(14,165,233,0.28)";

// Banner — тод цэнхэрээс бүдэг, гүн хувилбар.
export const KNOWLEDGE_BANNER_FROM = "#1D5673";
export const KNOWLEDGE_BANNER_TO = "#2C7EA1";
